export function CreateHTMLSpinner() {
  var divID = "spinner";
  var spinner = document.createElement("div");
  spinner.setAttribute("class", "spinner-border text-primary spinner");
  spinner.setAttribute("role", "status");
  spinner.setAttribute("id", divID);
  return spinner;
}
